import { observable } from 'mobx';

import { SerializedData, FetchOptions } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';
import { FlightsShoppingPwaFlightServicingResults } from '__generated__/api/types';

export class ServicingCriteriaStore extends Store {
  @observable public servicingCriteria: FlightsShoppingPwaFlightServicingResults.Variables;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public setCriteriaFromUrl(fetchOptions: FetchOptions) {
    const { query } = fetchOptions;

    this.servicingCriteria.flightsServicingCriteria.ancillaryId = query?.ancillaryId;
    this.servicingCriteria.flightsServicingCriteria.journeyContinuationId = query?.journeyContinuationId;
    this.servicingCriteria.flightsServicingCriteria.originalBookingId = query?.originalBookingId;
    this.servicingCriteria.flightsServicingCriteria.tripId = query?.tripId;
    this.servicingCriteria.flightsServicingCriteria.upsellOfferToken = query?.upsellOfferToken;
  }
}

ServicingCriteriaStore.DEFAULTS = {
  servicingCriteria: {
    flightsServicingCriteria: {
      ancillaryId: '',
      journeyContinuationId: '',
      originalBookingId: '',
      tripId: '',
      upsellOfferToken: ''
    }
  }
};
